<template>
  <div class="home">
    <p>企财通inapp_jsbridge测试 20230817-10:48</p>
    <a @click="toAbout">to about</a>
    <HelloWorld></HelloWorld>
    <p>{{ uaInfo }}</p>
    <!-- <img src="https://mmbiz.qpic.cn/sz_mmbiz_jpg/ASpCkb5xx0uTkEY7gZhzyt7ibJIYQ5oZgMn4cibo6Baeq0qFajQic8HaYjvWcBUKKicj3tTIYNuyxZXianNcoFeXOjw/640?wx_fmt=jpeg&wxfrom=5&wx_lazy=1&wx_co=1" alt="" srcset=""> -->
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "Home",
  components: {
    HelloWorld,
  },
  mounted: function () {
    this.uaInfo = navigator.userAgent;
    console.log("home mounted");
    setTimeout(() => {
      let vconDom = document.getElementById("__vconsole");
      vconDom.setAttribute("class", "show");
    }, 1000);
    
  },
  data: function () {
    return {
      uaInfo: "",
    };
  },
  methods:{
    toAbout(){
      this.$router.push({path:"/About"})
    },
  },
};
</script>
